<template>
  <!-- 揭西县人民医院 -->
  <div class="pageContent">
    <div class="hosName">榆林市第一医院绥德院区</div>
    <div class="ourterTitle">
      影像检查数字化报告/影像系统
    </div>
    <van-tabs class="outerVanTab" v-model:active="value71900008.active" @change="onClickTab" swipeable>
      <van-tab title="身份证号查询" name="1">
        <div class="bindDetails">
          <div class="IDNumber">
            <van-field
              v-model="value71900008.name71900008"
              placeholder="请输入姓名查询"
            />
          </div>
          <div class="IDNumber">
            <van-field
              v-model="IDcard"
              placeholder="请输入身份证号"
              maxlength="18"
              clearable
              @input.native="onIdNumber"
            />
          </div>
          
          <footer class="footer">
            <van-button type="primary" :disabled="rules" @click.native="nextFn"
              >下一步</van-button
            >
          </footer>
        </div>
      </van-tab>
      <van-tab title="手机号查询" name="2">
        <div class="bindDetails">
          <div class="IDNumber">
            <van-field
              v-model="value71900008.name71900008"
              placeholder="请输入姓名查询"
            />
          </div>
          <div class="IDNumber">
            <van-field
              v-model="phoneValue"
              placeholder="请输入手机号"
            />
          </div>
          <footer class="footer">
            <van-button type="primary" :disabled="rules" @click.native="nextFn"
              >下一步</van-button
            >
          </footer>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      value71900008: {
        name71900008: "",
        value1: "",
        active: '1'
      },
      phoneValue: "",
      IDcard: "",
      rules: true,
      currentDate: new Date(),
    };
  },
  watch: {
    value71900008:{
      handler: function(newVal, oldVal) {
        console.log(newVal)
        if(this.value71900008.active == 2) {
          if (newVal.name71900008 != "" && newVal.value1 != "") {
            this.rules = false;
          } else {
            this.rules = true;
          }
        }else if(this.value71900008.active == 1) {
          console.log(newVal)
          if (newVal.name71900008 != "" && newVal.value1.length == 18) {
            this.rules = false;
          } else {
            this.rules = true;
          }
        }
        
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onClickTab(name) {
      this.value71900008.active = name
      if(name == 2){//就诊时间
        this.value71900008.value1 = this.phoneValue
      }else if(name == 1){//身份证
        this.value71900008.value1 = this.IDcard
      }
    },
    onIdNumber() {
      if (this.value71900008.active == 1 && this.IDcard != "" && this.IDcard.length == 18) {
        this.rules = false;
        this.value71900008.value1 = this.IDcard
      } else {
        this.rules = true;
      }
      console.log(this.rules)
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value71900008", JSON.stringify(this.value71900008));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    // let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    // let value71900008 = JSON.parse(window.localStorage.getItem("value71900008"))
    // if (value71900008.value1 != "" && value71900008.name71900008 != "") {
    //   this.$router.push({
    //     path: "/reportListOuter",
    //   });
    // }
  },
};
</script>
<style lang="scss" scoped>
.hosName {
  font-size: 30px;
  padding: 65px 0 5px;
  color: rgb(164, 25, 16);
}
.ourterTitle {
  padding: 0 0 20px;
  font-size: 12px;
  color: rgb(51, 62, 80)
}
.bindDetails {
  width: 90%;
  margin: 0 auto;
}

</style>
